import React, { useState } from "react";
import { FaMinus, FaPlus, FaShieldAlt, FaUserShield, FaDatabase, FaClipboardCheck, FaServer,FaExclamationTriangle, FaSyncAlt, FaFileMedicalAlt, FaClock, FaTools } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcareDataSecurity/Incident.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Breach Detection & Investigation",
        "description": "Employs real-time monitoring, advanced Intrusion Detection Systems (IDS), and AI-powered behavioral analytics to detect unauthorized access, data breaches, and security anomalies. Rapidly investigates potential threats using forensic analysis and threat intelligence to prevent data exposure and system compromise."
    },
    {
        "title": "Immediate Incident Containment",
        "description": "Deploys automated threat response mechanisms to isolate infected systems, compromised user accounts, and vulnerable network segments. Implements zero-trust security policies and micro-segmentation to prevent the lateral movement of attackers while ensuring uninterrupted critical healthcare services."
    },
    {
        "title": "Forensic Analysis & Threat Intelligence",
        "description": "Conducts in-depth digital forensic investigations to trace the origin, tactics, techniques, and procedures (TTPs) used in cyberattacks. Integrates with global threat intelligence feeds to identify attack patterns, predict emerging threats, and strengthen proactive defenses against cybercriminal activities."
    },
    {
        "title": "Disaster Recovery Planning",
        "description": "Develops comprehensive disaster recovery (DR) and business continuity plans, including secure data backups, redundancy measures, and automated failover strategies. Ensures hospitals, clinics, and healthcare networks can swiftly restore operations with minimal downtime after cyber incidents or system failures."
    },
    {
        "title": "Ransomware Response & Mitigation",
        "description": "Implements rapid containment protocols to neutralize ransomware threats before they spread. Utilizes air-gapped, immutable backups, endpoint detection and response (EDR) tools, and AI-driven decryption solutions to recover encrypted patient records without complying with ransom demands. Provides training and proactive risk assessments to prevent future ransomware attacks."
    },
    {
        "title": "Regulatory Compliance & Reporting",
        "description": "Ensures full adherence to HIPAA, GDPR, NIST, and other healthcare cybersecurity frameworks. Automates compliance audits, breach reporting, and incident documentation to meet legal obligations and industry standards. Provides real-time insights into regulatory gaps and security risks for continuous improvement."
    }
]

const features = [
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "24/7 real-time monitoring for healthcare cyber threats." },
    { icon: <FaExclamationTriangle className="text-[#2a627a] text-lg" />, text: "Immediate alert systems for security breaches." },
    { icon: <FaSyncAlt className="text-[#2a627a] text-lg" />, text: "Automated system recovery and data backup solutions." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Access control mechanisms to contain threats." },
    { icon: <FaFileMedicalAlt className="text-[#2a627a] text-lg" />, text: "EHR security integration for medical data protection." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Compliance audits for post-incident analysis and prevention." }
];

const benefits = [
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Protects sensitive patient data from cyber threats." },
    { icon: <FaClock className="text-[#2a627a] text-lg" />, text: "Minimizes downtime to ensure continuous healthcare services." },
    { icon: <FaTools className="text-[#2a627a] text-lg" />, text: "Reduces financial losses from security incidents." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Enhances data backup and disaster recovery strategies." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Improves response times to cyberattacks in hospital networks." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Ensures regulatory compliance with HIPAA and GDPR." }
];
const cmsFeatures = [
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Incident Response Analyst – Identifies and mitigates security breaches." },
    { icon: <FaExclamationTriangle className="text-[#2a627a] text-lg" />, text: "Cybersecurity Engineer – Designs secure healthcare IT infrastructure." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Compliance Officer – Ensures adherence to regulatory standards post-incident." },
    { icon: <FaFileMedicalAlt className="text-[#2a627a] text-lg" />, text: "EHR Security Specialist – Protects patient records from data breaches." },
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Disaster Recovery Manager – Plans and executes system recovery procedures." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Threat Intelligence Analyst – Monitors emerging cyber threats in healthcare." }
];

const IR = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Incident Response & Recovery - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Incident Response & Recovery ensures swift detection, containment, and resolution of cybersecurity threats to minimize disruptions and protect healthcare data."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Incident Response & Recovery?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Incident Response & Recovery (IRR) is the process of identifying, managing, and mitigating security incidents in healthcare systems. It ensures quick containment, investigation, and recovery from cyber threats, ransomware attacks, data breaches, and system failures while maintaining compliance with HIPAA, GDPR, and other healthcare regulations.

                            At HIKEHEALTH GS, we provide proactive cybersecurity solutions that help healthcare providers, hospitals, and digital health platforms respond to cyber threats and recover operations with minimal disruption.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Secure Cloud Storage
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default IR;
